/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EventsInputs */

const th_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการแข่งขัน`)
};

const en_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const ja_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会`)
};

const zh_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事`)
};

const es_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const pt_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const id_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const fr_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements`)
};

const tl_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga event`)
};

const vi_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const ko_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

const de_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const ru_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События`)
};

const tr_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikler`)
};

const it_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi`)
};

const pl_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

const uk_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Події`)
};

const hi_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन`)
};

const ar_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعاليات`)
};

const ms_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const bn_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন`)
};

const zh_tw2_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const zh_hk2_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事`)
};

const ur_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹس`)
};

const fa_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویدادها`)
};

const sw_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio`)
};

const nl_events = /** @type {(inputs: EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenementen`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {EventsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const events = /** @type {((inputs?: EventsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EventsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_events(inputs)
	if (locale === "ja") return ja_events(inputs)
	if (locale === "zh") return zh_events(inputs)
	if (locale === "es") return es_events(inputs)
	if (locale === "pt") return pt_events(inputs)
	if (locale === "id") return id_events(inputs)
	if (locale === "fr") return fr_events(inputs)
	if (locale === "tl") return tl_events(inputs)
	if (locale === "vi") return vi_events(inputs)
	if (locale === "ko") return ko_events(inputs)
	if (locale === "de") return de_events(inputs)
	if (locale === "ru") return ru_events(inputs)
	if (locale === "tr") return tr_events(inputs)
	if (locale === "it") return it_events(inputs)
	if (locale === "pl") return pl_events(inputs)
	if (locale === "uk") return uk_events(inputs)
	if (locale === "hi") return hi_events(inputs)
	if (locale === "ar") return ar_events(inputs)
	if (locale === "ms") return ms_events(inputs)
	if (locale === "bn") return bn_events(inputs)
	if (locale === "zh-TW") return zh_tw2_events(inputs)
	if (locale === "zh-HK") return zh_hk2_events(inputs)
	if (locale === "ur") return ur_events(inputs)
	if (locale === "fa") return fa_events(inputs)
	if (locale === "sw") return sw_events(inputs)
	if (locale === "nl") return nl_events(inputs)
	return en_events(inputs)
});